<template>
    <div class="p-pet-single" v-if="pet" v-loading="loading">
        <div class="m-pet-navigation">
            <div class="u-goback" @click="goBack">返回列表</div>
        </div>
        <PublicNotice bckey="pet_ac" />
        <div class="m-pet-content flex">
            <petCard :petObject="pet" :lucky="luckyList"></petCard>
            <div class="m-pet-info">
                <h1 class="u-title">
                    <span class="u-name">{{ pet.Name }}</span>
                    <!-- <span class="u-type">{{ getPetType(pet.Class) }} · {{ getPetSource(pet.Source) }}</span> -->
                    <div class="m-pet-links">
                        <a class="u-link u-item" :href="getLink('item', item_id)" target="_blank"
                            ><i class="el-icon-collection-tag"></i>物品信息</a
                        >
                        <template v-if="achievement_id">
                            <em> | </em>
                            <a class="u-link u-achievement" :href="getLink('cj', achievement_id)" target="_blank"
                                ><i class="el-icon-trophy"></i>成就信息</a
                            >
                        </template>
                    </div>
                    <div class="u-meta u-shop" v-if="shopInfo.RewardsPrice || shopInfo.CoinPrice">
                        <!-- <span class="u-meta-label">商城价格：</span> --> 
                        <el-tag class="u-price-item u-rewards" v-if="shopInfo.RewardsPrice > 0">
                            积分<b>{{ shopInfo.RewardsPrice }}</b>
                            <i class="u-icon-rewards"></i>
                        </el-tag>
                        <el-tag class="u-price-item u-coin">
                            通宝<b>{{ shopInfo.CoinPrice }}</b>
                            <i class="u-icon-coin"></i>
                        </el-tag>
                    </div>
                </h1>
                <i class="u-stars">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="12" viewBox="0 0 12 12" fill="none" v-for="count in pet.Star" :key="count" v-bind:class="'u-star'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g><mask id="a" fill="#fff"><use xlink:href="#path_0"/></mask><g mask="url(#a)"><path fill-rule="evenodd" d="M4.577 2.704C5.21 1.568 5.527 1 6 1c.473 0 .79.568 1.423 1.704l.165.294c.18.323.27.484.41.591.14.107.314.146.664.225l.318.072c1.23.279 1.845.417 1.992.888.146.47-.274.96-1.112 1.941l-.217.253c-.238.279-.357.418-.411.59-.053.173-.035.359 0 .73l.034.339c.126 1.308.19 1.962-.194 2.253-.382.291-.958.025-2.11-.505l-.298-.136c-.327-.152-.49-.227-.664-.227-.173 0-.337.075-.665.226l-.297.138c-1.152.53-1.728.795-2.11.505-.383-.292-.32-.946-.193-2.254l.033-.338c.036-.372.054-.558 0-.73-.053-.173-.173-.312-.411-.59l-.217-.254c-.839-.98-1.258-1.47-1.112-1.941.147-.47.762-.61 1.992-.888l.318-.072c.35-.079.524-.119.665-.225.14-.107.23-.268.41-.591l.163-.294z" fill="#ffa811"/></g></g><defs><path id="path_0" d="M0 0h12v12H0z"/></defs></svg>
                    <!-- <i class="el-icon-star-on" v-for="count in pet.Star" :key="count"></i> -->
                </i>
                <div class="u-metas">
                    <div class="u-meta u-number"><span class="u-meta-label">编号：</span>{{ pet.Index }}</div>
                    <div class="u-meta u-type"><span class="u-meta-label">分类：</span>{{ getPetType(pet.Class) }}</div>
                    <div class="u-meta u-score"><span class="u-meta-label">分数：</span>{{ pet.Score }}</div>
                    <div class="u-meta u-get-way">
                        <span class="u-meta-label">获取方式：</span>{{ getPetSource(pet.Source) }}
                    </div>
                    <div class="u-meta u-source">
                        <span class="u-meta-label">获取线索：</span>
                        <template v-for="item in getPetDesc(pet.OutputDes)">
                            <span :key="item.text">{{ cleanResourceText(item.text) }}</span>
                        </template>
                    </div>
                    <div class="u-meta u-desc">
                        <span class="u-meta-label">宠物说明：</span>
                        <span class="u-meta-value">
                            <template v-for="(item, index) in getPetDesc(pet.Desc)">
                                <span :key="index" v-html="item.text"></span>
                            </template>
                        </span>
                    </div>
                </div>
                <!-- 宠物技能 -->
                <div class="m-pet-skills">
                    <div class="u-skill" v-for="(skill, index) in petSkills" :key="index">
                        <el-popover trigger="hover" popper-class="m-pet-skill" :visible-arrow="false" placement="top">
                            <div class="u-skill-pop">
                                <div class="u-skill-name">{{ skill.Name }}</div>
                                <div class="u-skill-desc">{{ skill.Desc }}</div>
                            </div>
                            <img
                                slot="reference"
                                class="u-skill-icon"
                                :src="iconLink(skill.IconID)"
                                :alt="skill.Name"
                            />
                        </el-popover>
                    </div>
                </div>
            </div>
            <div class="m-pet-map" v-show="mapDisplay">
                <span class="u-header"> 捕获地图 </span>
                <!-- 地图组件 -->
                <pet-map :petId="parseInt(id)" @loaded="mapLoaded" />
            </div>
        </div>
        <!-- 宠物羁绊 -->
        <div class="m-pet-fetters" v-if="medalList && medalList.length">
            <div class="u-header">
                <svg xmlns="http://www.w3.org/2000/svg" width="31.531" height="31.531" viewBox="0 0 31.531 31.531" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.872 24.961l-2.539.412a2.59 2.59 0 01-1.961-.468 2.606 2.606 0 01-1.043-1.72l-.223-1.482-4.407 4.407a.835.835 0 00.438 1.413l2.801.523.523 2.801a.838.838 0 001.413.438l5.755-5.755-.422-.427a.471.471 0 00-.335-.142z"/><path d="M19.91 23.932l2.458.404a1.554 1.554 0 001.794-1.303l.37-2.458c.075-.492.383-.917.829-1.141l2.224-1.111a1.564 1.564 0 00.686-2.111L27.129 14a1.518 1.518 0 010-1.403l1.144-2.211c.19-.37.227-.802.098-1.199a1.57 1.57 0 00-.785-.911l-2.223-1.112a1.53 1.53 0 01-.829-1.14l-.37-2.458a1.556 1.556 0 00-.624-1.026 1.555 1.555 0 00-1.17-.279l-2.457.405a1.52 1.52 0 01-1.335-.434L16.828.459A1.568 1.568 0 0015.766 0a1.566 1.566 0 00-1.061.459l-1.75 1.773a1.52 1.52 0 01-1.335.434l-2.457-.405a1.554 1.554 0 00-1.17.279 1.556 1.556 0 00-.624 1.026l-.37 2.458a1.532 1.532 0 01-.83 1.14L3.947 8.276a1.568 1.568 0 00-.785.912c-.129.396-.093.829.097 1.199l1.144 2.211c.229.439.229.964 0 1.403l-1.143 2.21a1.563 1.563 0 00.687 2.111l2.224 1.111c.446.224.753.649.829 1.141l.37 2.458c.062.412.288.783.624 1.026a1.55 1.55 0 001.17.277l2.458-.404c.489-.082.987.08 1.335.436l1.75 1.771a1.55 1.55 0 001.059.459 1.55 1.55 0 001.059-.459l1.75-1.771a1.517 1.517 0 011.335-.435zm-4.144-1.39c-5.205-.026-9.431-4.266-9.431-9.477 0-5.21 4.226-9.451 9.431-9.478 5.205.026 9.432 4.268 9.432 9.478-.001 5.211-4.227 9.451-9.432 9.477z"/><path d="M15.766 4.955c-4.444.028-8.05 3.648-8.05 8.097 0 4.447 3.606 8.068 8.05 8.096 4.444-.027 8.05-3.648 8.05-8.096-.001-4.448-3.606-8.069-8.05-8.097zM29.833 26.11l-4.407-4.407-.223 1.482a2.615 2.615 0 01-3.004 2.188l-2.539-.412a.468.468 0 00-.335.143l-.422.427 5.755 5.755a.838.838 0 001.413-.438l.522-2.801 2.801-.523a.837.837 0 00.439-1.414z"/></svg>
                <span class="u-txt">宠物羁绊</span>
            </div>
            <!-- 羁绊信息 -->
            <petFetters :info="item" v-for="item in medalList" :key="item.ID" />
        </div>
        <!-- 宠物地图 -->
        <!-- <div class="u-map-title">捕获地图/获取攻略</div> -->

        <!-- 包含攻略、评论、历史版本、点赞等 书籍，宠物等物品为item, 声望成就等为achievement -->
        <pvx-user :id="item_id" name="宠物" type="item"></pvx-user>

        <!-- <div class="m-pet-wiki">
            <Wiki
                source_type="item"
                :source_id="item_id"
                :type="type"
                :id="id"
                title="获取攻略"
                :source_title="title"
            ></Wiki>
        </div>
        <WikiComments :type="type" :source-id="id" /> -->
    </div>
</template>

<script>
import PublicNotice from "@/components/PublicNotice";
import { getPet, getPets, getShopInfo, getPetSkill, getSkill, getPetLucky } from "@/service/pet";
import PvxUser from "@/components/PvxUser.vue";
import petCard from "@/components/pet/PetCard.vue";
import petFetters from "@/components/pet/PetFetters.vue";
// import Wiki from "@/components/wiki/Wiki.vue";
import petType from "@/assets/data/pet_type.json";
import petSource from "@/assets/data/pet_source.json";
import { iconLink, getLink } from "@jx3box/jx3box-common/js/utils";
import { postStat } from "@jx3box/jx3box-common/js/stat.js";

import dayjs from "@/plugins/day";
import PetMap from "@/components/pet/PetMap.vue";
// import WikiComments from "@jx3box/jx3box-common-ui/src/wiki/WikiComments";
export default {
    name: "PetSingle",
    props: [],
    components: {
        petCard,
        petFetters,
        // Wiki,
        PetMap,
        // WikiComments,
        PvxUser,
        PublicNotice,
    },
    data: function () {
        return {
            type: "pet",
            pet: "",
            petSkills: [],
            shopInfo: "",
            luckyList: [],
            medalList: [],
            mapDisplay: false,
            loading: false,
            search: "",
        };
    },
    computed: {
        id: function () {
            return this.$route.params.id;
        },
        item_id: function () {
            return this.pet?.ItemTabType + "_" + this.pet?.ItemTabIndex;
        },
        achievement_id: function () {
            return this.petWiki?.achievement_id;
        },
        client: function () {
            return this.$store.state.client;
        },
        title: function () {
            return this.pet?.Name;
        },
        params: function () {
            return {
                client: this.client,
            };
        },
    },
    watch: {
        id() {
            this.getPetInfo();
        },
    },
    methods: {
        // 获取宠物详情
        getPetInfo: function () {
            this.loading = true;
            getPet(this.id, this.params)
                .then((res) => {
                    this.pet = res.data;
                    this.medalList = res.data.medal_list;
                    this.loadPetSkills(res.data.__skills);
                    this.getShopInfo();
                    this.getPetMedal();
                })
                .finally(() => {
                    this.loading = false;
                    postStat(this.type, this.id);
                });
        },
        // 获取宠物技能信息
        loadPetSkills: function (data) {
            const levelIds = [];
            const skillIds = [];

            this.petSkills = [];

            for (const key in data) {
                // 技能等级
                if (key.startsWith("Level") && data[key]) {
                    levelIds.push(data[key]);
                }
                // 技能id
                if (key.startsWith("SkillID") && data[key]) {
                    skillIds.push(data[key]);
                }
            }

            getSkill({
                ids: skillIds.join(","),
                client: this.client,
            }).then((skillRes) => {
                levelIds.forEach((level, index) => {
                    let skills = skillRes.data.filter((skill) => skill.Level === level);

                    const skill = skills.find((_skill) => _skill.SkillID === skillIds[index]);

                    if (skill) {
                        this.petSkills.push(skill);
                    }
                });
            });
        },
        // 获取宠物商城价格
        getShopInfo() {
            const params = {
                item_type: this.pet.ItemTabType,
                item_id: this.pet.ItemTabIndex,
            };
            getShopInfo(params).then((res) => {
                this.shopInfo = res?.data || "";
            });
        },
        // 获取宠物种类
        getPetType: function (typeId) {
            const _petType = petType.find((item) => item.class === typeId);
            return _petType?.name || "";
        },
        // 获取宠物途径
        getPetSource: function (sourceId) {
            const _petSource = petSource.find((item) => ~~sourceId === ~~item.source);
            return _petSource?.name || "";
        },
        // 获取宠物描述
        getPetDesc: function (str) {
            const regex = /<text>text=(.*?)font=(\d+).*?<\/text>/gimsy;
            let matches = [];
            let match;
            while ((match = regex.exec(str))) {
                matches.push(match);
            }

            // 格式化分段
            let result = [];
            for (let group of matches) {
                result.push({
                    font: ~~group[2],
                    text: group[1].slice(1, -2).replace(/[\\n]/g, ""),
                });
            }
            return result;
        },
        goBack() {
            this.$router.push({ name: "list" });
        },
        goItem() {
            const { ItemTabType, ItemTabIndex } = this.pet;
            const link = getLink("item", `${ItemTabType}_${ItemTabIndex}`);

            window.open(link, "_blank");
        },
        // 获取福缘宠物id
        getPetLucky: function () {
            // 只有正式服有这玩意
            if (this.client === "std")
                getPetLucky(this.client).then((res) => {
                    let data = res.data;
                    let dateIndex = dayjs.tz(new Date()).format("MDD");
                    this.luckyList = data[dateIndex];
                });
        },
        getLink,
        // 获取宠物羁绊的宠物
        getPetMedal() {
            const ids = new Set();
            // 将每个羁绊的宠物id取出来
            this.medalList.forEach((item) => {
                item.pets = [];
                for (const key in item) {
                    if (key.includes("PetIndex") && item[key]) {
                        item.pets = [...item.pets, item[key]];
                        ids.add(item[key]);
                    }
                }
            });
            getPets({ ids: [...ids].join(","), client: this.client }).then((res) => {
                const list = res.data.list;
                // 将羁绊的宠物放入对应的羁绊中
                this.medalList.map((item) => {
                    const petList = list.filter((pet) => item.pets.includes(pet.Index));
                    this.$set(item, "petList", petList);
                    return item;
                });
            });
        },
        mapLoaded(visible) {
            this.mapDisplay = visible;
        },
        goSearch() {
            this.$router.push({ name: "list", params: { search: this.search } });
        },
        iconLink,
        cleanResourceText: function (str) {
            return str && str.startsWith("获取线索：") ? str.replace("获取线索：", "") : str;
        },
    },
    created: function () {
        this.getPetLucky();
    },
    mounted: function () {
        this.getPetInfo();
    },
};
</script>

<style lang="less">
@import "~@/assets/css/pet/single.less";
@import "~@/assets/css/pet/map.less";
</style>
